(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').factory('mx.SolutionBuilderAgent.ConditionsBuilder.Condition', ClassFactory);
	ClassFactory.$inject = ['mx.SolutionBuilderAgent.ConditionsBuilder.Helper', 'mx.SolutionBuilderAgent.ConditionsBuilder.Enums'];

	function ClassFactory(helper, ConditionsBuilderEnums) {
		const ConditionValueTypes = ConditionsBuilderEnums.ConditionValueTypes;
		const ConditionTypes = ConditionsBuilderEnums.ConditionTypes;
		const ConditionBuilderMode = ConditionsBuilderEnums.ConditionBuilderMode;

		function ConditionsBuilderCondition(options, config) {
			options = options || {};
			let value;
			let operator = 0;
			let valueType;

			Object.defineProperty(this, 'id', {
				enumerable: true,
				writable: true,
				value: options.Id || mx.components.Utils.guid(),
			});

			Object.defineProperty(this, 'parent', {
				writable: false,
				enumerable: false,
				value: options.parent,
			});

			Object.defineProperty(this, '_builderConfig', {
				writable: false,
				enumerable: false,
				value: config,
			});

			Object.defineProperty(this, 'name', {
				enumerable: true,
				writable: true,
				value: options.Name || '',
			});

			Object.defineProperty(this, 'displayValue', {
				enumerable: false,
				writable: true,
				value: value,
			});

			Object.defineProperty(this, 'value', {
				enumerable: true,
				get: function () {
					return value;
				},
				set: function (newValue) {
					value = newValue;
					if (this.valueTypeValue === ConditionValueTypes.Attribute) {
						if (
							Array.isArray(this.attributes) &&
							!this.attributes.some(function (attribute) {
								if (attribute.AttributeId === value) {
									this.selectedAttribute = attribute;
									this.displayValue = attribute.Title;
									return true;
								}
							}, this)
						) {
							this.selectedAttribute = undefined;
							this.displayValue = '';
							value = '';
						}
					} else if (this.valueTypeValue === ConditionValueTypes.Value) {
						if (this.conditionType === ConditionTypes.EnumerationReference) {
							if (Array.isArray(this.__enumeration)) {
								if (
									!(this.__enumeration || []).some(function (item) {
										if (item.value === value) {
											this.displayValue = item.title;
											return true;
										}
									}, this)
								) {
									this.displayValue = value;
								}
							} else if (typeof this.loadEnumeration === 'function') {
								this.loadEnumeration().then(
									function (enumeration) {
										this.__enumeration = enumeration || [];
										this.value = value;
									}.bind(this)
								);
							}
						} else if (this.conditionType === ConditionTypes.Date) {
							this.displayValue = new Date(value).toLocaleString();
						} else {
							this.displayValue = this.getDisplayValue();
						}
					} else {
						this.displayValue = this.getDisplayValue();
					}
					this.updateOutput();
				},
			});

			Object.defineProperty(this, 'conditionType', {
				writable: true,
				enumerable: true,
				value: options.ConditionType || ConditionTypes.String,
			});

			Object.defineProperty(this, 'selectedAttribute', {
				enumerable: false,
				writable: true,
			});

			Object.defineProperty(this, 'operators', {
				writable: false,
				enumerable: false,
				value: setupOperators(this.conditionType),
			});

			function setupOperators(conditionType) {
				const typeOperators = config.operators[conditionType];
				return options.Operators || (Array.isArray(typeOperators) ? [...typeOperators] : []);
			}

			Object.defineProperty(this, 'operator', {
				enumerable: true,
				set: function (newOperator) {
					const wasArray = this.operators[this.operator]?.isArray || false;

					const newOperatorValue = this.operators[newOperator];
					if (typeof newOperatorValue === 'undefined') {
						newOperator = 0;
					}
					operator = newOperator;

					if (this.operators[operator]?.isArray && !wasArray) {
						this.value = Array.isArray(this.value) ? this.value : [this.value || ''];
						if (this.value.length === 0) {
							this.value.push('');
						}
					} else if (!this.operators[operator]?.isArray && wasArray) {
						this.value = this.value[0];
					}
					this.updateOutput();
				},
				get: function () {
					return operator;
				},
			});

			Object.defineProperty(this, 'operatorValue', {
				enumerable: false,
				set: function (newOperator) {
					let selected;
					if (
						!this.operators.some((item) => {
							if (item.value === newOperator) {
								selected = item;
								return true;
							}
						})
					) {
						this.operator = 0;
					} else {
						this.operator = this.operators.indexOf(selected);
					}
					this.updateOutput();
				},
				get: function () {
					return (this.operators[this.operator] || {}).value;
				},
			});

			Object.defineProperty(this, 'operatorTitle', {
				enumerable: false,
				get: function () {
					return (this.operators[this.operator] || {}).title;
				},
			});

			Object.defineProperty(this, 'isArrayValue', {
				enumerable: false,
				get: function () {
					return this.operators[this.operator]?.isArray || false;
				},
			});

			Object.defineProperty(this, 'unconfigurableStartCondition', {
				enumerable: false,
				get: function () {
					return this.operators[this.operator]?.unconfigurableStartCondition || (this.startConditions || []).length <= 1;
				},
			});

			Object.defineProperty(this, 'unconfigurableValue', {
				enumerable: false,
				get: function () {
					return this.operators[this.operator]?.unconfigurableValue || false;
				},
			});

			Object.defineProperty(this, 'unconfigurableOperator', {
				enumerable: false,
				get: function () {
					return this.unconfigurableStartCondition && this.unconfigurableValue;
				},
			});

			Object.defineProperty(this, 'valueTypes', {
				writable: false,
				enumerable: false,
				value: this._builderConfig.valueTypes.enumeration,
			});

			Object.defineProperty(this, 'valueType', {
				enumerable: true,
				set: function (index) {
					const newValueType = this.valueTypes[index];
					if (typeof newValueType === 'undefined') {
						index = 0;
					}
					valueType = index;
					if (newValueType.value !== ConditionValueTypes.Attribute) {
						this.selectedAttribute = undefined;
					}
					if (newValueType.value === ConditionValueTypes.Value) {
						if (this.conditionType === ConditionTypes.EnumerationReference) {
							if (!Array.isArray(this.__enumeration) && typeof this.loadEnumeration === 'function') {
								this.loadEnumeration().then(
									function (enumeration) {
										this.__enumeration = enumeration || [];
									}.bind(this)
								);
							}
						}
					}
					value = '';
					this.displayValue = '';
					this.updateOutput();
				},
				get: function () {
					return valueType;
				},
			});

			Object.defineProperty(this, 'valueTypeValue', {
				enumerable: false,
				set: function (newValueType) {
					let selected;
					if (
						!this.valueTypes.some(function (item) {
							if (item.value === newValueType) {
								selected = item;
								return true;
							}
						})
					) {
						this.valueType = 0;
					} else {
						this.valueType = this.valueTypes.indexOf(selected);
					}
					this.updateOutput();
				},
				get: function () {
					return (this.valueTypes[this.valueType] || {}).value;
				},
			});

			Object.defineProperty(this, 'valueTypeTitle', {
				enumerable: false,
				get: function () {
					return this.valueTypes[this.valueType].title;
				},
			});

			Object.defineProperty(this, '_options', {
				enumerable: false,
				writable: false,
				value: options,
			});

			helper.definePropertiesForEnums('logicOperator', this);
			helper.definePropertiesForEnums('startCondition', this, options.StartConditions || []);

			Object.defineProperty(this, 'expanded', {
				value: true,
				enumerable: false,
				writable: true,
			});

			if (options.EnumLoader && typeof options.EnumLoader === 'function') {
				Object.defineProperty(this, 'loadEnumeration', {
					enumerable: false,
					value: function () {
						const self = this;
						return options.EnumLoader(this).then(function (enumeration) {
							self.__enumeration = enumeration;
							return enumeration;
						});
					},
				});
			}

			Object.defineProperty(this, 'properties', {
				enumerable: false,
				get: function () {
					return this.parent ? this.parent.properties : [];
				},
			});

			Object.defineProperty(this, 'attributes', {
				enumerable: false,
				get: function () {
					return this.parent ? this.parent.attributes : [];
				},
			});

			this.logicOperatorValue = options.LogicOperator;
			this.valueTypeValue = options.ValueType;
			this.value = options.Value || '';
			this.operatorValue = options.Operator;
			this.startConditionValue = options.ConditionStart;

			this.initialized = true;
			this.updateOutput();
		}

		ConditionsBuilderCondition.prototype = {
			toggleLogicalOperator: function () {
				this.logicOperator = (this.logicOperator + 1) % this.logicOperators.length;
				if (this.parent && this._builderConfig.mode === ConditionBuilderMode.disableDifferentOperatorsInGroup) {
					this.parent.setLogicOperatorForChildren(this.logicOperator);
				}
			},

			updateOutput: function () {
				if (!this.initialized) {
					return;
				}
				if (typeof this._builderConfig.conditionOutput === 'function') {
					this.output = this._builderConfig.conditionOutput(this);
				}
				if (this.parent && typeof this.parent.updateOutput === 'function') {
					this.parent.updateOutput();
				}
			},

			updateEnumerations: function () {
				if (typeof this._builderConfig.updateEnumerations === 'function') {
					this.output = this._builderConfig.updateEnumerations(this);
				}
			},

			addNewValue() {
				this.value.push('');
				this.updateOutput();
			},

			removeValue(index) {
				this.value.splice(index, 1);
				this.updateOutput();
			},

			getDisplayValue() {
				return Array.isArray(this.value) ? this.value.join(',  ') : this.value;
			},

			onArrayValueChange() {
				this.displayValue = this.getDisplayValue();
				this.updateOutput();
			},
		};

		return ConditionsBuilderCondition;
	}
})();
